import { type GetMetricQueryParams } from '@gonfalon/openapi/operations/getMetric';

import { createSuspenseQueryHook } from '../internal/createSuspenseQueryHook';
import { metrics } from '../queries/metrics';

/**
 * @deprecated Use `createQueryOptions` with `getMetric` and `useSuspenseQuery` directly.
 * See packages/rest-api/README.md for the recommended pattern.
 */
export const useSuspenseMetric = createSuspenseQueryHook(
  ({ projectKey, metricKey, params }: { projectKey: string; metricKey: string; params?: GetMetricQueryParams }) =>
    metrics.detail({ projectKey, metricKey, params }),
);
